import { put, takeLatest, call } from 'redux-saga/effects'
import fetchFromAPI, {
  getDefaultAutorizedHeaders,
  toFormData,
} from 'helpers/fetchFromApi'
import UrlHelper from 'helpers/url'
import * as ApiRouter from 'constants/apiRouting'
import NoticeHelper from 'helpers/notice'
import {
  API_URL_LICENSEE_LIST,
  API_URL_LICENSEE_TABLE,
  API_URL_LICENSEE_ITEM,
  API_URL_LICENSEE_LIST_BY_USER,
} from 'constants/index'
import { FETCH_PROFILE } from 'reducers/profile/reducer'
import { SHOW_NOTICE } from '../notice'
import {
  LICENSEE_FETCH_LIST,
  LICENSEE_GET_TABLE_DATA,
  LICENSEE_SET_TABLE_DATA,
  LICENSEE_FETCH_FORM_DATA,
  LICENSEE_CHANGE,
  LICENSEE_DISPLAY_TABLE,
  LICENSEE_DISPLAY_FORM,
  LICENSEE_DELETE,
  LICENSEE_FETCH_LIST_BY_USER,
  LICENSEE_FETCH_LIST_BY_USER_SUCCESS,
  UPDATE_LICENSEE_LOGO,
  UPDATE_LICENSEE_LOGO_SUCCESS,
  UPDATE_LICENSEE_LOGO_FAILURE,
  CLEAR_CURRENT_LICENSEE,
} from './reducer'

function* licenseeFetchList(action) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: `${API_URL_LICENSEE_LIST}${UrlHelper.getPsfsQuery(
        action.payload,
      )}`,
    })

    if (!response.error) {
      return action.promise
        ? yield call(action.promise.resolve, response)
        : yield put({ type: LICENSEE_DISPLAY_TABLE, listData: response })
    }
    console.log('LICENSEE GET LIST ERROR', response)
  } catch (error) {
    console.log('LICENSEE INTERFACE ERROR', error)
  }
}

function* licenseeFetchTableData(action) {
  try {
    yield put({ type: CLEAR_CURRENT_LICENSEE })
    const data = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: `${API_URL_LICENSEE_TABLE}${UrlHelper.getPsfsQuery(
        action.payload,
      )}`,
    })

    yield put({
      type: LICENSEE_SET_TABLE_DATA,
      tableData: data,
    })
  } catch (error) {
    console.log('LICENSEE INTERFACE ERROR', error)
  }
}

function* licenseeFetchListByUser() {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: API_URL_LICENSEE_LIST_BY_USER,
    })

    yield put({ type: LICENSEE_FETCH_LIST_BY_USER_SUCCESS, listData: response })
  } catch (error) {
    console.log('LICENSEE INTERFACE ERROR', error)
  }
}

function* licenseeFetchFormData(action) {
  try {
    const { entityId } = action.payload
    const formData = {
      licensee: {},
    }

    if (entityId) {
      formData.licensee = yield call(fetchFromAPI, {
        headers: getDefaultAutorizedHeaders(),
        partUrl: UrlHelper.create(API_URL_LICENSEE_ITEM, {
          id: action.payload.entityId,
        }),
      })
    }

    yield put({
      type: LICENSEE_DISPLAY_FORM,
      formData,
    })
  } catch (error) {
    console.log('LICENSEE INTERFACE ERROR', error)
  }
}

function* licenseeChange(action) {
  try {
    const { entityId, values } = action.payload
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      method: !entityId ? 'POST' : 'PUT',
      partUrl: !entityId
        ? API_URL_LICENSEE_LIST
        : UrlHelper.create(API_URL_LICENSEE_ITEM, { id: entityId }),
      data: values,
    })

    if (response.error) {
      return yield call(action.promise.resolve, response.errors)
    }

    yield put({
      type: SHOW_NOTICE,
      notice: NoticeHelper.createSuccessObj(
        `Licensee ${entityId === 0 ? 'create' : 'change'} successful`,
      ),
    })

    return yield call(action.promise.resolve, false)
  } catch (error) {
    throw new Error(`LICENSEE INTERFACE ERROR: ${error}`)
  }
}

function* licenseeDelete(action) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      method: 'DELETE',
      partUrl: UrlHelper.create(API_URL_LICENSEE_ITEM, {
        id: action.payload.entityId,
      }),
    })

    if (response === 204) {
      yield put({
        type: SHOW_NOTICE,
        notice: NoticeHelper.createSuccessObj('Licensee delete successful'),
      })

      return yield licenseeFetchTableData(action)
    }

    console.log('SITE DELETE UNKNOWN ERROR. RESPONSE: ', response)
  } catch (error) {
    console.log('SITES INTERFACE ERROR', error)
  }
}

function* updateLicenseeLogo(action) {
  const { fileData, entityId, message } = action.payload
  try {
    const value = yield call(fetchFromAPI, {
      data: toFormData({ logo: fileData }),
      headers: getDefaultAutorizedHeaders({
        'Content-Type': 'multipart/form-data',
        'X-HTTP-Method-Override': 'PUT',
      }),
      method: 'POST',
      partUrl: UrlHelper.createQuery(
        UrlHelper.create(ApiRouter.LICENSEE_UPDATE_LOGO, {
          licensee: entityId,
        }),
      ),
    })

    if (!value || !value.error) {
      yield put({ type: UPDATE_LICENSEE_LOGO_SUCCESS, payload: value })
      yield put({ type: FETCH_PROFILE })
      yield put({
        type: SHOW_NOTICE,
        notice: NoticeHelper.createSuccessObj(message),
      })
    } else {
      yield put({ type: UPDATE_LICENSEE_LOGO_FAILURE })
      console.error(value.errors)
    }
  } catch (error) {
    console.error(error.toString())
  }
}

function* licenseeSaga() {
  yield takeLatest(LICENSEE_FETCH_LIST, licenseeFetchList)
  yield takeLatest(LICENSEE_GET_TABLE_DATA, licenseeFetchTableData)
  yield takeLatest(LICENSEE_FETCH_FORM_DATA, licenseeFetchFormData)
  yield takeLatest(LICENSEE_CHANGE, licenseeChange)
  yield takeLatest(LICENSEE_DELETE, licenseeDelete)
  yield takeLatest(LICENSEE_FETCH_LIST_BY_USER, licenseeFetchListByUser)
  yield takeLatest(UPDATE_LICENSEE_LOGO, updateLicenseeLogo)
}

export default licenseeSaga
